import { Component, OnInit,Directive, HostListener } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

import { JwtHelperService } from '@auth0/angular-jwt'
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { decode } from '@angular/router/src/url_tree';
//import { userInfo } from 'os';
import {Screenfull} from 'screenfull';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  username: string;
  password: string;
  userid: string;
  fullname: string;
  cid: string;
  isfullscreen: boolean;
  jwtHelper = new JwtHelperService();

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
   this.openfullscreen();
    try {
      if (sessionStorage.getItem('fullname')) {
        if(sessionStorage.getItem('level')=="3"){
          this.router.navigate(['/all']);
        }else{
          this.router.navigate(['/home']);
        }
        
      } else {
        this.router.navigate(['/login']);
      }
    } catch (error) {
      console.log(error);
    }


  }

  async doLogin() {
    if (this.cid) {
      try {
        const rs: any = await this.authService.doLogin(this.cid);
        if (rs.ok == true) {
          const token = rs.token;
          sessionStorage.setItem('token', token);
          const decoded: any = this.jwtHelper.decodeToken(token);
          sessionStorage.setItem('fullname', decoded.fullname);
          sessionStorage.setItem('cid', decoded.cid);
          sessionStorage.setItem('userid', decoded.id);
          sessionStorage.setItem('level', decoded.level);
          sessionStorage.setItem('sup', decoded.subid);
          location.reload();
          //this.router.navigate(['/home']);

        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  openfullscreen() {
    // Trigger fullscreen
    const docElmWithBrowsersFullScreenFunctions = document.documentElement as HTMLElement & {
      requestFullscreen(): Promise<void>;
      mozRequestFullScreen(): Promise<void>;
      webkitRequestFullscreen(): Promise<void>;
      msRequestFullscreen(): Promise<void>;
    };

    // if (docElmWithBrowsersFullScreenFunctions.requestFullscreen) {
    //   //docElmWithBrowsersFullScreenFunctions. mozRequestFullScreen();
    //   docElmWithBrowsersFullScreenFunctions.requestFullscreen();
    // } else 
    if (docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen) { /* Firefox */
      docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen();
    } else if (docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen();
    } else if (docElmWithBrowsersFullScreenFunctions.msRequestFullscreen) { /* IE/Edge */
      docElmWithBrowsersFullScreenFunctions.msRequestFullscreen();
    }
    this.isfullscreen = true;
  }

}